import React from 'react';
import { TypographySmall } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import ConfirmationDialog from './ConfirmationDialog';
import { useTeamMembersContext } from '../../Context/TeamMembersContext';
import { useNotificationContext } from '@/Context/NotificationContext';

const TeamMemberRemoveDialog = () => {
    const { removeMember, activeDialog, closeDialog, selectedMember } = useTeamMembersContext();
    const { showFailToaster } = useNotificationContext();

    const handleClose = () => closeDialog();
    const handleConfirm = async () => {
        try {
            await removeMember(selectedMember!);
            handleClose();
        } catch (e) {
            showFailToaster();
        }
    };

    return (
        <ConfirmationDialog
            open={activeDialog === 'RemoveAccessConfirmation'}
            title={UIStrings.RemoveMemberAccess}
            actionButtonText={UIStrings.RemoveAccess}
            onClose={handleClose}
            onConfirm={handleConfirm}
        >
            <div>
                <TypographySmall>{`${UIStrings.AreYouSureYouWantToRemoveTheAccessForMemberName} `}</TypographySmall>
                <TypographySmall className="font-bold">{`${selectedMember?.firstName} ${selectedMember?.lastName}`}</TypographySmall>
            </div>
        </ConfirmationDialog>
    );
};

export default TeamMemberRemoveDialog;
